module.exports = __webpack_public_path__ + "img/mew-copy-address.215c0559.png";